import { registerQuery } from 'data-fetching-client';
import { ecosystemAppClient } from 'marketplace-ui-common/clients/ecosystemClient';
export const GET_OAUTH_URL = registerQuery({
  fieldName: 'oauthUrl',
  fetcher: ({
    offeringId,
    published
  }) => ecosystemAppClient.get(`/apps/${offeringId}/oauth-url?published=${published}`)
});